import Vue from 'vue'
import VueRouter from 'vue-router'


import Login from '@/views/login' //登录
import Index from '@/views/index' //首页
import Home from '@/views/home' //首页
import login_dev from '@/views/login/login_dev';

import UserCenter from '@/views/user-center' //用户中心
import UserAgreement from '@/views/user-agreement' //用户中心
import Register from '@/views/user-center/register/register-index' //个人中心-挂号记录
import UserSetting from '@/views/user-center/user-setting/user-setting-index' //个人中心-设置
import PersonalHome from '@/views/user-center/personal-home' //个人中心-个人主页
import FollowDoctor from '@/views/user-center/follow-doctor' //个人中心-关注医生
import FollowHospital from '@/views/user-center/follow-hospital' //个人中心-关注医院
import Question from '@/views/user-center/question';
import QuestionDev from '@/views/user-center/question_dev'; 
import EvaluateList from '@/views/user-center/evaluate-list' //个人中心-评价
import HealthyCard from '@/views/user-center/healthy-card/healthy-card-index' //个人中心-健康卡
import NewsCenter from '@/views/user-center/news-center' //个人中心-消息
import Report from '@/views/user-center/report-refer/index' //个人中心-报告列表
import HealthRecord from '@/views/user-center/health-record'
import SelfMedicalRecord from '@/views/user-center/self-medical' // 个人中心-自我病例
import SelfTest from '@/views/user-center/self-test' // 个人中心-自我病例

import { getToken, setToken, removeToken } from '@/utils/auth';
import { ls } from '@/utils/tool'

Vue.use(VueRouter)
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push (location) {
    return originalPush.call(this, location).catch((err) => err)
}
const routes = [
    //登录
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/login_dev',
        name: 'login_dev',
        component: login_dev
    },
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            name: '首页',
            title: '首页'
        },
        redirect: '/',
        children: [
            //首页
            {
                path: '/',
                name: 'index',
                meta: {
                    name: '首页',
                    hidden: true,
                    title: '首页'
                },
                component: Index,
            },
            //预约挂号
            {
                path: '/registered',
                name: 'registered',
                meta: {
                    name: '预约挂号',
                    title: '预约挂号'
                },
                component: () => import('@/views/registered'),
                redirect: '/registered/list',
                children: [
                    //预约挂号
                    {
                        path: 'list',
                        name: 'registered_list',
                        meta: {
                            name: '预约挂号',
                            hidden: true,
                            title: '预约挂号'
                        },
                        component: () => import('@/views/registered/list'),
                    },
                    //医院详情
                    {
                        path: 'hospital/:id',
                        name: 'hospital',
                        breadcrumbName: '医院详情',
                        meta: {
                            name: '医院详情',
                            title: '医院详情'
                        },
                        component: () => import('@/views/registered/hospital'),
                    },
                    {
                        path: 'hosbrief/:id',
                        naem: 'hosbrief',
                        meta: {
                            name: '具体详情',
                            title: '具体详情'
                        },
                        component: () => import('@/views/registered/hosbrief'),
                    },
                    //医生详情
                    {
                        path: 'doctor/:id/:active',
                        name: 'doctor',
                        breadcrumbName: '医生详情',
                        meta: {
                            name: '医生详情',
                            title: '医生详情'
                        },
                        component: () => import('@/views/registered/doctor'),
                    },
                    //科室详情
                    {
                        path: 'dept/:id',
                        name: 'dept',
                        breadcrumbName: '科室详情',
                        meta: {
                            name: '科室详情',
                            title: '科室详情'
                        },
                        component: () => import('@/views/registered/dept'),
                    },
                    {
                        path: 'department/:id',
                        name: 'department',
                        breadcrumbName: '具体详情',
                        meta: {
                            name: '具体详情',
                            title: '具体详情'
                        },
                        component: () => import('@/views/registered/department'),
                    },
                ],
            },
            //科室查找
            {
                path: '/office',
                name: 'office',
                meta: {
                    name: '科室查找',
                },
                component: () => import('@/views/office'),
                redirect: '/office/list',
                children: [
                    //科室查找
                    {
                        path: 'list',
                        name: 'office_list',
                        meta: {
                            name: '科室查找',
                            hidden: true,
                            title: '科室查找'
                        },
                        component: () => import('@/views/office/list'),
                    },
                ],
            },
            // 智能导诊
            {
                path: '/smart',
                name: 'smart',
                meta: {
                    name: '智能导诊',
                },
                component: () => import('@/views/smart'),
                // redirect: '/smart/index',
                children: [
                    {
                        path: '/smart/index',
                        name: 'smart-index'
                    }
                ]
            },
            // 智能导诊
            {
                path: '/check',
                name: 'check',
                meta: {
                    name: '智能导诊',
                },
                component: () => import('@/views/check'),
                // redirect: '/smart/index',
                children: [
                    {
                        path: '/check/index',
                        name: 'check-index'
                    }
                ]
            },
            //新闻公告
            {
                path: '/news-bulletin',
                name: 'news-bulletin',
                meta: {
                    name: '新闻公告',
                },
                component: () => import('@/views/news-bulletin'),
                redirect: '/news-bulletin/list',
                children: [
                    //新闻公告
                    {
                        path: 'list',
                        name: 'list',
                        meta: {
                            name: '新闻公告',
                            hidden: true,
                            title: '新闻公告'
                        },
                        component: () => import('@/views/news-bulletin/list'),
                    },
                    //新闻公告详情
                    {
                        path: 'detail/:id',
                        name: 'detail',
                        breadcrumbName: '新闻公告详情',
                        meta: {
                            name: '新闻公告详情',
                            title: '新闻公告详情'
                        },
                        component: () => import('@/views/news-bulletin/detail'),
                    },
                ],
            },
            //支付
            {
                path: '/payment',
                name: 'payment',
                meta: {
                    name: '支付',
                },
                component: () => import('@/views/payment'),
            },
            //信息确认
            {
                path: '/sure-Information',
                name: 'sure-Information',
                meta: {
                    name: '信息确认',
                    title: '信息确认'
                },
                component: () => import('@/views/payment/sure-Information'),
            },
            //搜索结果
            {
                path: '/search-result',
                name: 'search-result',
                meta: {
                    name: '搜索结果',
                    title: '搜索结果'
                },
                component: () => import('@/views/search'),
            },
            //搜索结果
            {
                path: '/pay-success',
                name: 'pay-success',
                meta: {
                    name: '支付成功',
                    title: '支付成功'
                },
                component: () => import('@/views/payment/pay-success'),
            },
        ],
    },
    //用户中心
    {
        path: '/user-center',
        name: 'user-center',
        component: UserCenter,
        redirect: '/user-center/register',
        children: [
            {
                //个人中心-挂号记录
                path: '/user-center/register',
                component: Register,
                children: [
                    {
                        //挂号记录
                        path: '',
                        name: 'register',
                        meta: {
                            name: '挂号记录',
                            title: '挂号记录'
                        },
                        component: () => import('@/views/user-center/register/register'),
                    },
                    {
                        //挂号详情
                        path: 'register-detail',
                        name: 'register-detail',
                        meta: {
                            name: '挂号详情',
                            title: '挂号详情'
                        },
                        component: () =>
                            import('@/views/user-center/register/register-detail'),
                    },
                ],
            },
            {
                //个人中心-设置
                path: '/user-center/user-setting',
                component: UserSetting,
                children: [
                    {
                        path: '',
                        name: 'user-setting',
                        meta: {
                            name: '设置',
                            title: '设置'
                        },
                        component: () =>
                            import('@/views/user-center/user-setting/user-setting'),
                    },
                    {
                        //修改手机号
                        path: 'setting-phone',
                        name: 'setting-phone',
                        meta: {
                            name: '修改手机号',
                            title: '修改手机号'
                        },
                        component: () =>
                            import('@/views/user-center/user-setting/setting-phone'),
                    },
                    {
                        //修改手机号
                        path: 'setting-login',
                        name: 'setting-login',
                        meta: {
                            name: '账号解绑',
                            title: '账号解绑'
                        },
                        component: () =>
                            import('@/views/user-center/user-setting/setting-login'),
                    },
                ],
            },
            {
                //个人中心-个人主页
                path: '/user-center/personal-home',
                name: 'personal-home',
                meta: {
                    name: '个人主页',
                    title: '个人主页'
                },
                component: PersonalHome,
            },
            {
                //个人中心-关注的医生
                path: '/user-center/follow-doctor',
                name: 'follow-doctor',
                meta: {
                    name: '关注的医生',
                    title: '关注的医生'
                },
                component: FollowDoctor,
            },
            {
                //个人中心-关注的医院
                path: '/user-center/follow-hospital',
                name: 'follow-hospital',
                meta: {
                    name: '关注的医院',
                    title: '关注的医院'
                },
                component: FollowHospital,
            },
            {
              //个人中心-自我病例
              path: '/user-center/self-medical',
              name: 'self-medical',
              meta: {
                  name: '自我病例',
                  title: '自我病例'
              },
              component: SelfMedicalRecord
            },
            {
              //个人中心-自我检测
              path: '/user-center/self-test',
              name: 'self-test',
              meta: {
                  name: '自我检测',
                  title: '自我检测'
              },
              component: SelfTest
            },
            {
                //个人中心-关注的科室
                path: '/user-center/follow-department',
                name: 'follow-department',
                meta: {
                    name: '关注的科室',
                    title: '关注的科室'
                },
                component: () => import('@/views/user-center/follow-department.vue'),
            },
            {
                //个人中心-关注的疾病
                path: '/user-center/follow-disease',
                name: 'follow-disease',
                meta: {
                    name: '关注的疾病',
                    title: '关注的疾病'
                },
                component: () => import('@/views/user-center/follow-disease.vue'),
            },
            {
                //个人中心-问卷调查
                path: '/user-center/question',
                name: 'question',
                meta: {
                    name: '问卷调查',
                    title: '问卷调查'
                },
                component: Question,
            },
            {
                //报告查询
                path: '/user-center/report-refer',
                name: 'report-index',
                meta: {
                    name: '报告查询',
                    title: '报告查询'
                },
                redirect: '/user-center/report-refer',
                component: Report,
                children: [
                    {
                        path: '/user-center/report-refer',
                        name: 'report-refer',
                        meta: {
                            name: '报告查询',
                            title: '报告查询'
                        },
                        component: () => import('@/views/user-center/report-refer/report-refer'),
                    },
                    {
                        path: '/user-center/report-refer/inspect',
                        name: 'inspect',
                        meta: {
                            name: '检查报告',
                            title: '检查报告'
                        },
                        component: () => import('@/views/user-center/report-refer/inspect')
                    },
                    {
                        path: '/user-center/report-refer/test',
                        name: 'test',
                        meta: {
                            name: '检验报告',
                            title: '检验报告'
                        },
                        component: () => import('@/views/user-center/report-refer/test')
                    },
                    {
                        path: '/user-center/report-refer/exam',
                        name: 'exam',
                        meta: {
                            name: '体检报告',
                            title: '体检报告'
                        },
                        component: () => import('@/views/user-center/report-refer/exam')
                    },
                    {
                        path: '/user-center/report-refer/bacterial',
                        name: 'bacterial',
                        meta: {
                            name: '细菌培养报告',
                            title: '细菌培养报告'
                        },
                        component: () => import('@/views/user-center/report-refer/bacterial')
                    },
                    {
                        path: '/user-center/report-refer/drug',
                        name: 'drug',
                        meta: {
                            name: '药敏试验报告',
                            title: '药敏试验报告'
                        },
                        component: () => import('@/views/user-center/report-refer/drug')
                    }
                ]
            },
            {
                //报告查询
                path: '/user-center/health-record',
                name: 'health-record',
                meta: {
                    name: '健康档案浏览器',
                    title: '健康档案浏览器'
                },
                component: HealthRecord,
            },
            {
                //个人中心-问卷详情
                path: '/user-center/question_dev',
                name: 'question_dev',
                meta: {
                    name: '问卷调查',
                    title: '问卷调查'
                },
                component: QuestionDev,
            },
            {
                //个人中心-我的评价
                path: '/user-center/evaluate-list',
                name: 'evaluate-list',
                meta: {
                    name: '我的评价',
                    title: '我的评价'
                },
                component: EvaluateList,
            },
            {
                //个人中心-健康卡
                path: '/user-center/healthy-card',
                component: HealthyCard,
                redirect: '/user-center/healthy-card',
                children: [
                    {
                        //电子健康卡管理
                        path: '',
                        name: 'healthy-card',
                        meta: {
                            name: '电子健康卡管理',
                            title: '电子健康卡管理'
                        },
                        component: () =>
                            import('@/views/user-center/healthy-card/healthy-card'),
                    },
                    {
                        //编辑健康卡
                        path: 'change-healthy-card',
                        name: 'change-healthy-card',
                        meta: {
                            name: '编辑健康卡',
                            title: '编辑健康卡'
                        },
                        component: () =>
                            import('@/views/user-center/healthy-card/change-healthy-card'),
                    },
                ],
            },
            {
                //个人中心-消息中心
                path: '/user-center/news-center',
                name: 'news-center',
                meta: {
                    name: '消息中心',
                    title: '消息中心'
                },
                component: NewsCenter,
            },
            {
                //个人中心-健康工具
                path: '/user-center/health-tools',
                name: 'health-tools',
                meta: {
                    name: '健康工具',
                    title: '健康工具'
                },
                component: () => import('@/views/user-center/health-tools/health-tools'),
            }
        ],
    },
    {
        path: '/user-agreement',
        name: 'user-agreement',
        component: UserAgreement,
        children: [
            {
                path: '/user-agreement/agreement',
                meta: {
                    name: '用户协议',
                    title: '用户协议'
                },
                component: () => import('@/components/UserAgreement'),
            },
            {
                path: '/user-agreement/privacy',
                meta: {
                    name: '隐私协议',
                    title: '隐私协议'
                },
                component: () => import('@/components/PrivacyAgreement'),
            },
            {
                path: '/user-agreement/relation',
                meta: {
                    name: '联系我们',
                    title: '联系我们'
                },
                component: () => import('@/views/user-agreement/relation'),
            },
            {
                path: '/user-agreement/help',
                meta: {
                    name: '帮助中心',
                    title: '帮助中心'
                },
                component: () => import('@/views/user-agreement/help'),
            }
        ]
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/error-page/404'),
        hidden: true
    },
    {
        path: '*',
        redirect: '/404',
        hidden: true
    },
    {
        path: '',
        redirect: '/',
        hidden: true
    }

]

const router = new VueRouter({
    routes,
})
// 使用router.beforeEach对路由进行遍历，设置title
router.beforeEach((to, from, next) => {
    let token = ls.get('token')
    if (to.name == "doctor" || to.name == 'personal-home') {
        if (token == null || token == '') {
            next({ path: "/login" })
        } else {
            if (to.meta.title) {
                //判断是否有标题
                document.title = '淮南智慧医疗-' + to.meta.title
            } else {
                document.title = '淮南智慧医疗'
            }
            next()
        }
    } else {
        if (to.path.includes('user-center')) {
            if (!ls.get('token')) next("/")
        }
        if (to.meta.title) {
            //判断是否有标题
            document.title = '淮南智慧医疗-' + to.meta.title
        } else {
            document.title = '淮南智慧医疗'
        }

        next()
    }


})
export default router
